import {initializeApp, getApp} from "firebase/app"
import { getAuth , signOut } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  //databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  firestoreDB:process.env.REACT_APP_FIREBASE_FIRESTORE_DB
};

export const App = initializeApp(firebaseConfig);
//export const dataB = getDatabase(App);
export const auth = getAuth();
export const db = getFirestore(App);
export const DB = getFirestore(getApp(), firebaseConfig.firestoreDB);
export const storage = getStorage(App);
export function logout() {
  return signOut(auth);
}
